<template>
  <a-modal :title="null" :width="1000" :visible="visible" @cancel="handleCancel" :footer="null">
    <div class="title-area">
      <div class="title">{{ stuData?.title }} - 个人测评报告</div>
      <div class="info">{{ stuData.className }} {{ stuData.studentName }}</div>
      <div v-if="stuData?.time" class="info">{{ stuData?.time }}</div>
    </div>
    <div class="eval-box">
      <div class="text-card" v-if="mbtiObj">
        <div style="font-size: 28px; font-weight: bold; color: #1783e8">
          {{ mbtiObj.name }}
        </div>
        <div class="title-1" style="margin-top: 5px">测评结果</div>
        <div class="title-1" style="margin-top: 10px">
          {{ mbtiObj.dignity }}
        </div>
      </div>
      <RadarChart
        v-else-if="radarChartData?.indicator?.length > 1"
        height="260px"
        :chartStyle="{ width: '35%' }"
        radius="80"
        :fields="radarChartData.legend"
        :indicator="radarChartData.indicator"
        :dataSource="radarChartData.data"
      />
      <div class="text-card" v-else>
        <div style="font-size: 28px; font-weight: bold; color: #1783e8">
          {{ radarChartData.indicator?.[0]?.name || '指标项：无' }}
        </div>
        <div class="title-1" style="margin-top: 5px">测评结果</div>
        <div class="title-1" style="margin-top: 10px">
          测评得分：{{ radarChartData?.data?.[0]?.value?.[0] || 0 }}分
        </div>
      </div>

      <div class="score-box box-shadow-1">
        <EmptyData
          :dataSource="mbtiObj ? [mbtiObj] : emphasisScoreList"
          :styleObj="{ marginTop: '50px' }"
        >
          <template slot="content">
            <div v-if="mbtiObj">
              <div class="content" style="margin: 5px 0">
                <span style="font-weight: bold">名词解释：</span>
                <div v-html="mbtiObj.account"></div>
              </div>
              <div class="content" style="margin: 5px 0">
                <span style="font-weight: bold">性格分析：</span>
                <div v-html="mbtiObj.analyze"></div>
              </div>
              <div class="content">
                <span style="font-weight: bold">职业建议：</span>
                <div v-html="mbtiObj.results"></div>
              </div>
            </div>
            <template v-else>
              <div v-for="(item, index) in emphasisScoreList" :key="index">
                <div class="title-1" style="margin: 5px 0">
                  {{ item.pointName }}（{{ item.ruleName }}）
                </div>
                <div class="content">
                  {{ item.suggestion }}
                </div>
              </div>
            </template>
          </template>
        </EmptyData>
      </div>
    </div>
    <div v-if="pointScoreList.length > 0" class="factor-analysis">
      <div class="analysis-title">{{ stuData?.title }}</div>
      <div v-for="(item, index) in pointScoreList" :key="index" class="score-list">
        <div class="title-1" style="margin-top: 10px">
          {{ item.pointName }}：{{ item.score }}分
          <span style="margin-left: 10px">{{ item.ruleName }}</span>
        </div>
        <div v-if="!mbtiObj" style="margin-top: 10px">
          结果分析：{{ item.resultAnalysis || '无' }}
        </div>
        <div v-if="!mbtiObj" style="margin-top: 8px">测评建议：{{ item.suggestion || '无' }}</div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import RadarChart from '@/components/echartZyz/components/RadarChart'
import { getAction } from '@api/manage'
import { extractLetters, formatSeconds } from '@/utils/util'
import mbtiData from './mbtiData'

export default {
  name: 'CreateEvaluation',
  components: {
    RadarChart,
  },
  data() {
    return {
      visible: false,
      stuData: {},
      radarChartData: {},
      pointScoreList: [],
      emphasisScoreList: [],
      evalRecordList: [],
      mbtiObj: null,
    }
  },
  methods: {
    showModal(data, index) {
      this.visible = true
      if (!data.id) return
      getAction('/schoolEvaluationRecord/personalEvaluationReport', {
        recordId: data.id,
      }).then((res) => {
        if (res.success) {
          const { chartData, pointScoreList, schoolEvaluation, schoolEvaluationRecord } = res.result
          this.radarChartData = chartData
          this.stuData = {
            title: schoolEvaluation?.name || '',
            time: formatSeconds(schoolEvaluationRecord?.speedTime || 0),
            className: schoolEvaluationRecord.className,
            studentName: schoolEvaluationRecord.studentName,
          }
          this.pointScoreList = pointScoreList
          if (this.stuData.title.substring(0, 4) === 'MBTI') {
            const matchStr = this.pointScoreList.reduce(
              (acc, item) => acc + extractLetters(item.ruleName),
              ''
            )
            if (mbtiData[matchStr]) {
              console.log('匹配字符串：', mbtiData[matchStr])
              this.mbtiObj = mbtiData[matchStr]
            }
          }
          console.log('pointScoreList:', this.pointScoreList)
          this.emphasisScoreList = pointScoreList.filter((item) => item.suggestion)
          console.log('雷达图数据：', this.radarChartData)
        }
      })
    },
    hideModal() {
      this.visible = false
      this.mbtiObj = null
    },
    handleCancel() {
      this.hideModal()
    },
  },
}
</script>
<style scoped lang="less">
.score-box {
  height: 260px;
  padding: 10px;
  margin-left: 15px;
  border-radius: 5px;
  flex: 1;
  overflow-y: auto;
}
.title-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #1783e8;
  }
  .info {
    font-size: 14px;
    color: #999999;
  }
}
.title {
  font-size: 16px;
  font-weight: bold;
}
.eval-box {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  //   align-items: center;
  .content {
    line-height: 2;
  }
  .text-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 35%;
  }
}
.factor-analysis {
  margin-top: 20px;
  .analysis-title {
    font-size: 20px;
    font-weight: bold;
    color: #1783e8;
  }
}
</style>
